const ErrorType = Object.freeze({
  RETRY_LATER: 'RETRY_LATER',
  RETRY_LATER_UI: 'RETRY_LATER_UI',
  RETRY_LATER_NEW_VEHICLE: 'RETRY_LATER_NEW_VEHICLE',
  CONTACT_SERVICE_PARTNER: 'CONTACT_SERVICE_PARTNER',
  MAINTENANCE: 'MAINTENANCE',
  NO_VIN: 'NO_VIN',
  NO_CONTEXT: 'NO_CONTEXT',
  NO_COMPANYID: 'NO_COMPANYID',
  NO_BASEURL: 'NO_BASEURL',
  NO_JWE: 'NO_JWE',
});

export default ErrorType;
